(function (window, document) {
  'use strict';

  var P = window.Printara;
  if (!P) return;

  var state = {
    data: null,
    active: null,
    lastVariantId: '',
    customerMediaSelected: false,
    customerMediaWidths: [],
    customerMediaLength: null,
    displayElement: null,
    placementObserver: null,
    placementFrame: null
  };

  function getData() {
    state.data = P.product.getData() || state.data || {
      productMedia: null,
      variants: {},
      hasMediaOption: false
    };

    return state.data;
  }

  function getActive(variantId) {
    var data = getData();
    var variants = data.variants || {};
    var variantMedia =
      variants[String(variantId || P.product.getVariantId())] || null;

    return variantMedia || data.productMedia || null;
  }

  function getWidths(media) {
    if (!media && state.customerMediaSelected) {
      return state.customerMediaWidths.slice();
    }

    var active = media || state.active || getActive();

    if (!active || !Array.isArray(active.media_widths)) return [];

    return active.media_widths
      .map(Number)
      .filter(function (width) {
        return !isNaN(width) && width > 0;
      })
      .sort(function (a, b) {
        return a - b;
      });
  }

  function getLength(media) {
    if (
      !media &&
      state.customerMediaSelected &&
      state.customerMediaLength > 0
    ) {
      return state.customerMediaLength;
    }

    var active = media || state.active || getActive();
    var length = parseFloat(active && active.media_length);

    return isNaN(length) || length <= 0 ? null : length;
  }

  function moveDisplayToVariantLocation(display, sectionId) {
    if (!display || !sectionId) return;

    var picker = document.getElementById(
      'variant-selects-' + sectionId
    );

    if (!picker) return;

    var controls = picker.querySelectorAll(
      'select[name^="options["], input[name^="options["]'
    );
    var mediaGroup = null;

    controls.forEach(function (control) {
      var match = String(control.name || '').match(/^options\[(.+)\]$/i);

      if (match && match[1].trim().toLowerCase() === 'media') {
        mediaGroup = control.closest('.product-form__input');
      }
    });

    var anchor = mediaGroup || picker;

    if (anchor.nextElementSibling !== display) {
      anchor.insertAdjacentElement('afterend', display);
    }
  }

  function scheduleDisplayPlacement() {
    if (state.placementFrame !== null) return;

    state.placementFrame = window.requestAnimationFrame(function () {
      state.placementFrame = null;

      var data = getData();
      var sectionId = data && data.sectionId;
      if (!sectionId) return;

      var display =
        document.getElementById('media-display-' + sectionId) ||
        state.displayElement;

      if (!display) return;

      state.displayElement = display;
      moveDisplayToVariantLocation(display, sectionId);
    });
  }

  function startDisplayPlacementObserver() {
    if (
      state.placementObserver ||
      !document.body ||
      typeof window.MutationObserver !== 'function'
    ) {
      return;
    }

    state.placementObserver = new window.MutationObserver(
      scheduleDisplayPlacement
    );

    state.placementObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function updateDisplay(media) {
    var data = getData();
    var sectionId = data.sectionId;

    if (!sectionId) return;

    var display =
      document.getElementById('media-display-' + sectionId) ||
      state.displayElement;

    if (!display) return;

    state.displayElement = display;
    moveDisplayToVariantLocation(display, sectionId);

    var nameLabel = display.querySelector(
      '#media-name-' + sectionId
    );
    var nameValue = display.querySelector(
      '#media-name-value-' + sectionId
    );
    var link = display.querySelector(
      '#media-link-' + sectionId
    );
    var linkText = display.querySelector(
      '#media-link-text-' + sectionId
    );

    if (!link || !linkText) return;

    var hasUrl = !!(media && media.url);
    display.hidden = !hasUrl;
    link.hidden = !hasUrl;

    if (!hasUrl) {
      if (nameLabel) nameLabel.hidden = true;
      link.removeAttribute('href');
      return;
    }

    link.href = media.url;

    var brandName = media.brandName
      ? String(media.brandName).trim()
      : '';

    linkText.textContent = brandName
      ? 'View ' + brandName + ' media specifications'
      : 'View media specifications';

    if (nameLabel && nameValue) {
      var productMedia = data.productMedia || null;
      var showLabel =
        data.hasOnlyDefaultVariant === true &&
        data.hasMediaOption === false &&
        !!(productMedia && productMedia.brandName);

      nameLabel.hidden = !showLabel;

      if (showLabel) {
        nameValue.textContent = String(productMedia.brandName).trim();
      }
    }
  }

function updateProperties(media) {
  var name = media && media.name ? String(media.name).trim() : '';

  P.forms.setPropertyAll('Media', name, {
    marker: 'media',
    disableWhenEmpty: true
  });

  document
    .querySelectorAll('[name="properties[_Media]"]')
    .forEach(function (input) {
      input.value = '';
      input.disabled = true;
    });
}

  function updateActiveMedia(variantId) {
    var selectedVariantId = variantId || P.product.getVariantId();
    var media = getActive(selectedVariantId);

    state.active = media;
    state.lastVariantId = String(selectedVariantId || '');
    window.activeProductMedia = media;

    updateDisplay(media);
    updateProperties(media);

    P.emit('product:media:update', {
      variantId: selectedVariantId,
      media: media
    });
  }

  function setCustomerMedia(widths, lengthInches) {
    state.customerMediaSelected = true;
    state.customerMediaWidths = (Array.isArray(widths) ? widths : [widths])
      .map(function (width) {
        return parseFloat(String(width).replace(/[^0-9.]/g, ''));
      })
      .filter(function (width) {
        return !isNaN(width) && width > 0;
      })
      .filter(function (width, index, all) {
        return all.indexOf(width) === index;
      })
      .sort(function (a, b) {
        return a - b;
      });

    var parsedLength = parseFloat(
      String(lengthInches == null ? '' : lengthInches).replace(/[^0-9.]/g, '')
    );

    state.customerMediaLength =
      !isNaN(parsedLength) && parsedLength > 0
        ? parsedLength
        : null;

    P.emit('product:media:update', {
      customerSupplied: true,
      customerMediaWidths: state.customerMediaWidths.slice(),
      customerMediaLength: state.customerMediaLength,
      media: state.active || getActive()
    });
  }

  function clearCustomerMedia() {
    state.customerMediaSelected = false;
    state.customerMediaWidths = [];
    state.customerMediaLength = null;

    P.emit('product:media:update', {
      customerSupplied: false,
      media: state.active || getActive()
    });
  }

  function init() {
    getData();
    startDisplayPlacementObserver();
    updateActiveMedia();

    document.addEventListener('change', function (event) {
      var variantInput =
        event.target.closest &&
        event.target.closest('input[name="id"], select[name="id"]');

      if (!variantInput) return;

      window.setTimeout(function () {
        var form = variantInput.closest('form[action*="/cart/add"]');
        updateActiveMedia(P.product.getVariantId(form));
      }, 50);
    });

    document.addEventListener('variant:change', function (event) {
      var variantId =
        event.detail && event.detail.variant && event.detail.variant.id;

      window.setTimeout(function () {
        updateActiveMedia(variantId);
      }, 0);
    });

    document.addEventListener(
      'pointerdown',
      function (event) {
        var button =
          event.target.closest &&
          event.target.closest(
            'form[action*="/cart/add"] button[type="submit"], ' +
              'form[action*="/cart/add"] input[type="submit"]'
          );

        if (!button) return;

        updateActiveMedia(
          P.product.getVariantId(
            button.closest('form[action*="/cart/add"]')
          )
        );
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form =
          event.target.closest &&
          event.target.closest('form[action*="/cart/add"]');

        if (!form) return;

        updateActiveMedia(P.product.getVariantId(form));
      },
      true
    );

    window.setInterval(function () {
      var current = String(P.product.getVariantId() || '');

      if (current !== state.lastVariantId) {
        updateActiveMedia(current);
      }
    }, 300);
  }

  P.media = {
    getData: getData,
    getActive: function () {
      return state.active || getActive();
    },
    getWidths: getWidths,
    getLength: getLength,
    update: updateActiveMedia,
    setCustomerMedia: setCustomerMedia,
    setCustomerMediaWidths: setCustomerMedia,
    clearCustomerMedia: clearCustomerMedia
  };

  P.util.ready(init);

  document.addEventListener('shopify:section:load', function () {
    getData();
    startDisplayPlacementObserver();
    updateActiveMedia();
  });
})(window, document);